import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=2192435e&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=2192435e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192435e",
  null
  
)

export default component.exports